import { render, staticRenderFns } from "./yous.vue?vue&type=template&id=84bd3ade&scoped=true"
import script from "./yous.vue?vue&type=script&lang=js"
export * from "./yous.vue?vue&type=script&lang=js"
import style0 from "./yous.vue?vue&type=style&index=0&id=84bd3ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bd3ade",
  null
  
)

export default component.exports